import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { Severity, ServerResponseError, ServerResponseSuccess, ToastNotification } from '@/types/Toast';

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<ToastNotification[]>([]);

  const addToast = (severity: Severity, title: string, detail: string, life: number = 3000) => {
    const id = Math.random() * 1000;

    const newToast: ToastNotification = {
      id: id,
      severity: severity,
      title: title,
      detail: detail,
      life: life,
    };
    toasts.value.unshift(newToast);
  };

  const success = (response: ServerResponseSuccess) => {
    if (response.data) {
      if (response.data.success === true) {
        addToast('success', 'Success', response.data?.message || '');
        return true;
      } else if (response.data.success === false) {
        addToast('error', 'Error', response.data?.message || '');
      }
    }
    return false;
  };

  const successAll = (responses: ServerResponseSuccess[]) => {
    let result = true;
    responses.forEach((resp) => {
      if (resp.data?.success === false) {
        result = false;
      }
    });
    return result;
  };

  const error = (response: ServerResponseError, life: number = 3000) => {
    const summary = response.status ? `Error: ${response.status}` : 'Error';
    let detail = '';

    if (response.response && response.response.data) {
      if (response.response.data.message) {
        detail = response.response.data?.message;
      }
    } else if (response.message) {
      detail = response.message;
    }

    addToast('error', summary, detail, life);
  };

  const manual = (severity: Severity, detail: string, life: number = 3000) => {
    const title = severity.charAt(0).toUpperCase() + severity.slice(1);
    addToast(severity, title, detail, life);
  };

  const remove = (id: number) => {
    toasts.value = toasts.value.filter(item => item.id !== id);
  };

  return {
    // List of Toasts
    toasts,

    // Add Toasts
    error,
    manual,
    success,
    successAll,

    // Remove Toasts
    remove,
  };
});
